export const GET_CHATBOT_DATA = "GET_CHATBOT_DATA";
export const GET_CHATBOT_DATA_SUCCESS = "GET_CHATBOT_DATA_SUCCESS";
export const GET_CHATBOT_DATA_FAILED = "GET_CHATBOT_DATA_FAILED";

export const CHATBOT_ADD_COMMENT = "CHATBOT_ADD_COMMENT";
export const CHATBOT_ADD_COMMENT_SUCCESS = "CHATBOT_ADD_COMMENT_SUCCESS";
export const CHATBOT_ADD_COMMENT_FAILED = "CHATBOT_ADD_COMMENT_FAILED";

export const CHATBOT_GET_COMMENT_HISTORY = "CHATBOT_GET_COMMENT_HISTORY";
export const CHATBOT_GET_COMMENT_HISTORY_SUCCESS = "CHATBOT_GET_COMMENT_HISTORY_SUCCESS";
export const CHATBOT_GET_COMMENT_HISTORY_FAILED = "CHATBOT_GET_COMMENT_HISTORY_FAILED";

export const CHATBOT_CLOSE_QUERY = "CHATBOT_CLOSE_QUERY";
export const CHATBOT_CLOSE_QUERY_SUCCESS = "CHATBOT_CLOSE_QUERY_SUCCESS";
export const CHATBOT_CLOSE_QUERY_FAILED = "CHATBOT_CLOSE_QUERY_FAILED";
